import { Pipe, PipeTransform } from '@angular/core';
import { PLATFORM_TYPE_INFO, IPlatform } from '@root/config';

@Pipe({ name: 'thirdparty' })
export class ThirdpartyPipe implements PipeTransform {
  transform(value: number): IPlatform {
    return PLATFORM_TYPE_INFO[value] ?
      PLATFORM_TYPE_INFO[value] :
      { name: value };
  }
}
